import styled from "styled-components";
import CertificateCardCore from "./CertificateCardCore";
import { FiMoreVertical } from "react-icons/fi";
import goTo from "../../../../controllers/goTo";
import { useContext, useState } from "react";
import Context from "../../../../Context";
import PopupOptions from "../../../applicationUI/PopupOptions";
import CustomButton from "../../../helperComponents/CustomButton";
import DeleteItemPopup from "../../../applicationUI/DeleteItemPopup";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--accentSurfaceSubtle);
  border: 1px solid var(--borderAccent);
  border-radius: 10px;
  padding: 15px;
  color: var(--elementDim);
  width: 100%;
  gap: 30px;

  ${({ $isButton }) => {
    if ($isButton) {
      return ` 
      cursor: pointer;
      &:hover {
        background: var(--surface);
      }`;
    }
  }}

  ${({ $makeRed }) => {
    if ($makeRed) {
      return ` 
        color: #d12000 !important;
      `;
    }
  }}

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Image = styled.img`
  height: auto;
  width: 100%;
  max-height: 50vh;
  border-radius: 10px;
  object-fit: cover;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
`;

const BubbleLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 90%;
  flex-wrap: wrap;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
`;

const Desc = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 18px;
  white-space: pre-wrap; /* Preserve line breaks and wrap text */
  /* color: var(--element); */
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export default function CertificateCard({ data }) {
  const { loggedInUser, setForm } = useContext(Context);
  let itemId = data._id;
  const [isDeleted, setIsDeleted] = useState(false);
  let itemType = "CERTIFICATE";

  if (isDeleted) return null;

  return (
    <Container>
      <CertificateCardCore data={data.data} ngo={data.ngo} user={data.user} />

      <Buttons>
        <CustomButton
          onClick={openMoreMenu}
          style={{
            width: "30px",
            height: "40px",
            padding: 0,
            gap: "0px",
          }}
          iconStyle={{ fontSize: "15px", padding: 0 }}
          icon={<FiMoreVertical />}
        ></CustomButton>
      </Buttons>
    </Container>
  );

  function goToEditPage() {
    goTo(`/manage-certificate/?itemId=${itemId}`)();
  }

  function goToDeletePage() {
    if (!itemType)
      return window.popupAlert("Delete is not supported for this item");

    setForm({
      title: "Delete",
      component: (
        <DeleteItemPopup
          itemId={itemId}
          itemType={itemType}
          callback={() => {
            setIsDeleted(true);
            window.popupAlert("Done");
          }}
        />
      ),
    });
  }

  function openMoreMenu() {
    let menuOptions = [];

    if (loggedInUser) {
      if (
        loggedInUser._id == data.senderUserId ||
        loggedInUser._id == data.senderUserId
      ) {
        menuOptions.push({ label: "Delete", onClick: goToDeletePage });
      }

      if (loggedInUser._id == data.senderUserId) {
        menuOptions.push({ label: "Edit", onClick: goToEditPage });
      }
    }

    setForm({
      title: "Options",
      component: <PopupOptions options={menuOptions} />,
    });
  }
}
